import styled from 'styled-components'

import breakpoints from '../../theme/breakpoints'
import Link from '../Link'

import FooterContact from './FooterContact'
import FooterProduct from './FooterProduct'
import FooterLegal from './FooterLegal'
import FooterDisclaimer from './FooterDisclaimer'

export const Container = styled.footer`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding: 3rem 4rem 6rem 4rem;
  width: 100%;
  height: auto;
  background-color: ${(props) => props.theme.colors.neonBlue};

  ${breakpoints.up('tablet')} {
    padding: 4rem 2rem 8rem 2rem;
  }
`

export const FirstWrapper = styled.div`
  max-width: 980px;
  width: 100%;
`

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: space-between;
  max-width: ${(props) => props.theme.sizes.desktop}px;

  ${breakpoints.up('tablet')} {
    flex-direction: row;
  }
`

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-top: 3.2rem;

  ${breakpoints.up('tablet')} {
    text-align: left;
    margin-top: 0;

    &:first-child {
      align-items: flex-start;
    }

    &:last-child {
      margin-top: 0;
    }
  }
`

export const DefaultLink = styled(Link)`
  ${breakpoints.down('tablet')} {
    display: block;
    width: max-content;
    margin: auto;
  }

  ${breakpoints.up('tablet')} {
    align-self: flex-start;
    margin-bottom: 3.2rem;
  }
`

export const Logo = styled.img`
  width: 8.5rem;
  height: 6.2rem;

  ${breakpoints.up('tablet')} {
    width: 9rem;
    height: 6rem;
  }
`

export const Contact = styled(FooterContact)``

export const Product = styled(FooterProduct)``

export const Legal = styled(FooterLegal)``

export const Disclaimer = styled(FooterDisclaimer)``
